module.exports = __webpack_public_path__ + "static/img/wrp1075.393f0ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wrp1075.jpg
// module id = DFwn
// module chunks = 0